// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1D7_V","imageUploader":"EGiftCard_imageUploader__XrDFA"};